import { useMedplum } from '@medplum/react-hooks';
import { useEffect, useRef } from 'react';
import { initializeApiClient } from '../api';
import { initializeBillingClient } from '../api/billing';

/**
 * Hook to initialize the API client with the Medplum client
 * This should be used once at the app level
 */
export function useApiInitialization(): void {
  const medplum = useMedplum();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initializeApiClient(medplum);
      initializeBillingClient(medplum);
      initialized.current = true;
    }
  }, [medplum]);
}
